<template>
  <div class="report" v-if="load">
    <limit-detail-menu v-model="date"></limit-detail-menu>
    <div class="main">
      <h2 class="main-title">Історія змін по картці</h2>
      <h2 class="main-title">{{ $route.params.number_cart}} — {{ data.card.cardDescription}}</h2>
      <div class="main-header flex-justify" >
        <div class="inner-addon">
          <button v-if="item.length >0 || dateFilter.length !== 0 || itemPeriod.length >0" @click="item=[]; itemPeriod=[]; dateFilter=[]" class="dropbtn" v-tooltip.top-center="'Скинути всі фільтри'" ><svg class="hover" width="30" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 4L9 12V18L15 21V12L20 4H4Z" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M29 12L20 21M20 12L29 21" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          </button>
        </div>
        <div class="header-right">
          <div class="select" >
            <select v-model="top">
              <option value=10>10</option>
              <option value=20>20</option>
              <option value=40>40</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </div>
        </div>
      </div>
      <section class="limit">
        <header>
          <div class="col-td">
            <div class="dropdown">
              <button @click="isActiveDate=!isActiveDate" class="dropbtn" >
                <svg :class="{active: dateFilter.length>0}" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L6 9V15L12 18V9L17 1H1Z" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <div :class="{show: isActiveDate}" class="dropdown-content">
                <div class="addon left-addon">
                  <date-picker
                      v-model="dateFilter"
                      type="datetime"
                      range
                      :lang="lang"
                      :disabled-date="disabledFilterDate"
                      format="DD.MM.YYYY HH:mm:ss"
                      placeholder="Select datetime range"
                  ></date-picker>
                </div>
              </div>
            </div>
            ДАТА ЗМІНИ</div>
          <div class="col-td">
            <div class="dropdown">
              <button class="dropbtn" >
                <svg  width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"></svg>
              </button>
            </div>
            ВИДИ ПАЛЬНОГО,  ПОСЛУГА
          </div>
          <div class="col-td">
            <div class="dropdown">
              <button @click="isActiveType=!isActiveType" class="dropbtn" >
                <svg :class="{active: item.length>0}" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L6 9V15L12 18V9L17 1H1Z" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <div id="myDropdownType" :class="{show: isActiveType}" class="dropdown-content">
                <div class="addon left-addon">
                  <button  @click="item=[]" class="dropbtn" v-tooltip.top-center="'Скинути'" ><svg class="hover" width="30" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 4L9 12V18L15 21V12L20 4H4Z" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M29 12L20 21M20 12L29 21" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  </button>
                </div>
                <div class="checkbox" v-for="typeLimit in typeLimits" :key="typeLimit.id" >
                  <input type="checkbox" class="custom-checkbox" v-model="item" :id="'typeLimit_' + typeLimit.id" :value="typeLimit.id"  />
                  <label :for="'typeLimit_' + typeLimit.id">{{ typeLimit.name }}</label>
                </div>
              </div>
            </div>
            Тип ліміту
          </div>
          <div class="col-td">
            <div class="dropdown">
              <button @click="isActivePeriod=!isActivePeriod" class="dropbtn" >
                <svg :class="{active: itemPeriod.length>0}" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L6 9V15L12 18V9L17 1H1Z" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <div id="myDropdownPeriod" :class="{show: isActivePeriod}" class="dropdown-content">
                <div class="addon left-addon">
                  <button  @click="itemPeriod=[]" class="dropbtn" v-tooltip.top-center="'Скинути'" ><svg class="hover" width="30" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 4L9 12V18L15 21V12L20 4H4Z" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M29 12L20 21M20 12L29 21" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  </button>
                </div>
                <div class="checkbox" v-for="periodLimit in periodLimits" :key="periodLimit.id" >
                  <input type="checkbox" class="custom-checkbox" v-model="itemPeriod" :id="'category_' + periodLimit.id" :value="periodLimit.id"  />
                  <label :for="'category_' + periodLimit.id">{{ periodLimit.name }}</label>
                </div>
              </div>
            </div>
            Періодичність
          </div>
          <div class="col-td">
            <div class="dropdown">
              <button class="dropbtn" >
                <svg  width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"></svg>
              </button>
            </div>
            <a @click.stop="sort=OrderByLimit.reverse()[0]"> ЛІМІТ
              <span class="arrow">
                <svg :class="{active: sort==2}" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 6L6 1L1 6" stroke="#C4C4C4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg :class="{active: sort==1}" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6 6L11 1" stroke="#C4C4C4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              </span>
            </a>
          </div>
        </header>

        <div class="table-row" v-for="(tr, i) in data.data" :key="i">
          <div class="col-td desktop" style="width: 10%" >{{tr.period | formatOnlyDate }}</div>
          <div class="col-td desktop">{{tr.goodsList}}</div>
          <div class="col-td desktop">{{tr.limitType}}</div>
          <div class="col-td desktop">{{tr.periodType}}</div>
          <div class="col-td desktop">{{tr.limit}}</div>
        </div>
      </section>
      <div class="container">
        <paginate v-if="data.total.totalCount/top > 1"
                  :page-count="Math.ceil(data.total.totalCount/top)"
                  :click-handler="changePage"
                  :page-range="4"
                  :margin-pages="4"
                  :initial-page="page"
                  :prev-text="'Попередня'"
                  :next-text="'Наступна'"
                  :container-class="'pagination'">
        </paginate>
        <div class="pagination-info">
          Показується з {{page * top - top + 1}} по {{data.pageTotal.countOnPage === Number(top) ? page * top :  data.total.totalCount}} із {{data.total.totalCount}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import moment from "moment";
import LimitDetailMenu from "../components/LimitDetailMenu";
import Paginate from "vuejs-paginate";
import DatePicker from "vue2-datepicker";
import qs from "qs";
export default {
  name: 'HistoryLimitsStatus',
  components: {
    LimitDetailMenu,
    Paginate,
    DatePicker
  },
  watch: {
    date: function (){
      this.load = false
      this.getData()
    },
    dateFilter: function (){
      // this.load = false
      this.getData()
    },
    page: function () {
      // this.load = false
      this.getData()
    },
    top: function () {
      // this.load = false
      this.getData()
      this.page = 1
    },
    item: function () {
      // this.load = false
      this.getData()
    },
    itemPeriod: function () {
      // this.load = false
      this.getData()
    },
    sort: function () {
      // this.load = false
      this.getData()
    },
  },
  data() {
    return {
      load: false,
      date: [new Date(moment().format('YYYY, MM, 01') ), new Date() ],
      isActiveDate: false,
      isActiveType: false,
      isActivePeriod: false,
      dateFilter: [],
      data: [],
      item: [],
      itemPeriod: [],
      sort: 1,
      page: 1,
      top: 10,
      lang: {
        monthFormat: 'MMMM'
      },
      OrderByLimit: [2,1],
      typeLimits: [
        {
          id: 2,
          name: "грн."
        },
        {
          id: 3,
          name: "л."
        }
      ],
      periodLimits: [
        {
          id: 1,
          name: "Доба"
        },
        {
          id: 2,
          name: "Місяць"
        },
        {
          id: 3,
          name: "До повного використання"
        }
      ]
    }
  },
  created() {
    this.getData()
  },
  mounted () {

  },
  computed:{
    transactionDates(){
      if (this.dateFilter.length === 0 || this.dateFilter[0]===null || this.dateFilter[1]===null) {
        return {begDate: moment(this.date[0]).format('YYYY-MM-DD') + ' 00:00:00',
          endDate: moment(this.date[1]).format('YYYY-MM-DD') + ' 23:59:59'}
      } else {
        return {begDate: moment(this.dateFilter[0]).format('YYYY-MM-DD HH:mm:ss'),
          endDate: moment(this.dateFilter[1]).format('YYYY-MM-DD HH:mm:ss')}
      }
    },
  },
  methods: {
    disabledFilterDate: function (date){
      return date > this.date[1] || date < this.date[0]
    },
    changePage: function (pageNum){
      this.page = pageNum
    },
    getData: function (){

      this.axios.get('/userservice/v1/Card/'+this.$route.params.number_cart+'/history', {params:
            {
              startDate: this.transactionDates.begDate,
              endDate:  this.transactionDates.endDate,
              sortingCardHistory: this.sort,
              limitTypes: this.item,
              limitPeriods: this.itemPeriod,
              top: this.top,
              page: this.page
            },
        paramsSerializer: params => {return qs.stringify(params)}
      }).then(
          (resp) => {
            this.data = resp.data
          })
          .catch(error => {
            console.log('error_get_data');
            console.log(error);
            this.errored = true;
          })
          .finally(() => (
              this.load = true)
          )
    },
  }
}
</script>